module.exports = __webpack_public_path__ + "img/Tinkercad.aa0d7454.png";